module.exports = __webpack_public_path__ + "media/images/noticia03-ori-f91060a857ba3dd20082bc816df7818f.jpg";